import { useState, useEffect, useId } from "react";
import AdminAPI from "../../services/AdminAPI";

const EXCLUDED_ROLES = new Set(["student"]);

let _cachedStaff = null;

async function fetchStaffList() {
  if (_cachedStaff) return _cachedStaff;
  try {
    const res = await AdminAPI.getStaffUsers();
    const users = Array.isArray(res) ? res : [];
    _cachedStaff = users
      .filter(u => !EXCLUDED_ROLES.has((u.role || "").toLowerCase()))
      .map(u => ({
        value: u.name || u.email || "",
        label: `${u.name || u.email || ""}${u.role ? ` (${u.role})` : ""}`,
      }))
      .filter(u => u.value);
    return _cachedStaff;
  } catch {
    return [];
  }
}

export function useStaffList() {
  const [staff, setStaff] = useState([]);
  useEffect(() => {
    fetchStaffList().then(setStaff);
  }, []);
  return staff;
}

const INPUT_CLS = "h-[42px] border border-[#e6ecf3] rounded-[10px] px-3 text-[13px] text-[#233445] bg-white outline-none focus:border-[#2d81c1] w-full";

export default function StaffSelect({ value, onChange, placeholder = "Search or type a name…", className }) {
  const id = useId();
  const staff = useStaffList();
  const listId = `staff-list-${id}`.replace(/:/g, "");

  return (
    <>
      <input
        list={listId}
        value={value}
        onChange={e => onChange(e.target.value)}
        placeholder={staff.length ? placeholder : "Loading staff…"}
        className={className || INPUT_CLS}
        autoComplete="off"
      />
      <datalist id={listId}>
        {staff.map((s, i) => (
          <option key={i} value={s.value}>{s.label}</option>
        ))}
      </datalist>
    </>
  );
}
